module.exports = __webpack_public_path__ + "static/brascol-girl-power-539632ea1f4d39249eb6c16561896f4a.jpg";